import React from 'react'
import styled from 'styled-components'
import { Icon, color, typography } from '@primer-io/goat'

import Box from 'ds/Box'
import Clickable from 'components/Clickable'
import { ArrowRight } from '@primer-io/goat-icons'

const IconWrapper = styled.div`
	position: absolute;
	bottom: 18px;
	right: 18px;
`

const StyledCard = styled(Box).attrs(props => ({
	gap: 8,
	padding: 20,
	...props,
}))`
	color: inherit !important; /* FIXME ek: this can be removed when we use Goat everywhere */
	${typography('body-large')}

	${IconWrapper} svg {
		stroke: ${color('gray-500')};
		transition: stroke 0.2s ease;
	}

	&:hover,
	&:focus {
		text-decoration: none !important;
		${IconWrapper} svg {
			stroke: ${color('gray-900')};
		}
	}
`

const Card = ({ children, link, noArrow, as = 'div', ...rest }) => (
	<StyledCard as={link ? Clickable : as} to={link} {...rest}>
		{children}
		{link && !noArrow && (
			<IconWrapper>
				<Icon as={ArrowRight} />
			</IconWrapper>
		)}
	</StyledCard>
)

export default Card
